/*
 * <anzu-loop> — plays a short muted video loop only while it's on screen.
 *
 * The markup already carries autoplay/muted/loop/playsinline, so the loop works with no JS
 * at all. This adds two things the platform won't do on its own:
 *   - pauses once the loop scrolls out of view, so a decorative 2s clip isn't decoding
 *     frames for the rest of the page
 *   - honours prefers-reduced-motion by never starting it and leaving the poster frame up
 *
 * play() is promise-based and rejects on some browsers (low-power mode, no user gesture);
 * that rejection is swallowed deliberately — the poster is a perfectly good fallback.
 */
(function () {
  function reduceMotion() {
    return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  class AnzuLoop extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loopReady) return;
      this.dataset.loopReady = '1';

      this.video = this.querySelector('video');
      if (!this.video) return;

      if (reduceMotion()) {
        this.video.removeAttribute('autoplay');
        this.video.pause();
        this.classList.add('is-static');
        return;
      }

      if (!('IntersectionObserver' in window)) return; // native autoplay carries it

      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) self.play();
        else self.video.pause();
      }, { rootMargin: '25% 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    play() {
      var p = this.video.play();
      if (p && typeof p.catch === 'function') p.catch(function () { /* poster stands in */ });
    }
  }

  if (!customElements.get('anzu-loop')) {
    customElements.define('anzu-loop', AnzuLoop);
  }

  window.theme = window.theme || {};
  window.theme.AnzuLoop = AnzuLoop;
})();
